import React from 'react'
import styled from '@emotion/styled'
import { useAppDispatch } from '../../state/hooks'
import {
  setCreativeDrawerData,
  setCreativeDrawerOpen,
} from '../../state/appSlice'
import { CreativeDrawerView } from './CreativeDrawer'
import { theme } from '../../mui'
import AddIcon from '@mui/icons-material/Add'

interface CreateNewMetaAdElementProps {}

const S = {
  Wrapper: styled.div`
    width: 20rem;
    min-height: 30rem;
    height: 100;
    border: 1px dashed ${theme.palette.text.disabled};
    border-radius: 1rem;
    color: ${theme.palette.text.disabled};
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.2s;
    &:hover {
      border: 1px dashed ${theme.palette.text.primary};
      color: ${theme.palette.text.primary};
    }
  `,
}

const CreateNewMetaAdElement = ({}: CreateNewMetaAdElementProps) => {
  const dispatch = useAppDispatch()

  const onCreateAdClick = () => {
    dispatch(
      setCreativeDrawerData({
        view: CreativeDrawerView.TEXT,
        metaAdFragmentRequest: null,
      })
    )
    dispatch(setCreativeDrawerOpen(true))
  }

  return (
    <S.Wrapper onClick={onCreateAdClick}>
      <AddIcon />
      <div>Create a new Ad...</div>
    </S.Wrapper>
  )
}

export default CreateNewMetaAdElement
